<template>
  <div class="page-law-exam-top10">
    <div class="report-shell">
      <div class="hero">
        <img :src="heroImage" class="hero-image" alt="易错 TOP10 考前集中突破" />
      </div>

      <div class="subject-tabs" role="tablist" aria-label="学科切换">
        <button
          v-for="subject in subjects"
          :key="subject.key"
          type="button"
          class="subject-tab"
          :class="{ active: activeSubject === subject.key }"
          :aria-selected="activeSubject === subject.key"
          role="tab"
          @click="setActiveSubject(subject.key)"
        >
          {{ subject.label }}
        </button>
      </div>

      <div class="subject-content" role="tabpanel">
        <img
          v-if="activeSubjectImage"
          :src="activeSubjectImage"
          class="top10-image"
          :alt="activeSubjectLabel + '易错 TOP10'"
        />
        <div v-else class="subject-empty" aria-label="暂无该学科内容"></div>
      </div>
    </div>
  </div>
</template>

<script>
import heroImage from '@/assets/law-exam/Group 2027493.png'
import civilTop10Image from '@/assets/law-exam/民法.png'
import criminalTop10Image from '@/assets/law-exam/刑法.png'
import theoryTop10Image from '@/assets/law-exam/理论法.png'
import privateInternationalTop10Image from '@/assets/law-exam/国际私法.png'
import publicInternationalTop10Image from '@/assets/law-exam/国际公法.png'
import economicInternationalTop10Image from '@/assets/law-exam/国际经济法.png'
import intellectualPropertyTop10Image from '@/assets/law-exam/知识产权法.png'
import economicTop10Image from '@/assets/law-exam/经济法.png'
import commercialTop10Image from '@/assets/law-exam/商法.png'
import civilProcedureTop10Image from '@/assets/law-exam/民诉法.png'
import administrativeTop10Image from '@/assets/law-exam/行政法.png'
import criminalProcedureTop10Image from '@/assets/law-exam/刑诉法.png'

export default {
  name: 'HomeLawExamTop10',
  data() {
    return {
      heroImage,
      activeSubject: 'civil',
      subjects: [
        { key: 'civil', label: '民法', image: civilTop10Image },
        { key: 'criminal', label: '刑法', image: criminalTop10Image },
        { key: 'theory', label: '理论法', image: theoryTop10Image },
        { key: 'private-international', label: '国际私法', image: privateInternationalTop10Image },
        { key: 'public-international', label: '国际公法', image: publicInternationalTop10Image },
        { key: 'economic-international', label: '国际经济法', image: economicInternationalTop10Image },
        { key: 'intellectual-property', label: '知识产权法', image: intellectualPropertyTop10Image },
        { key: 'economic', label: '经济法', image: economicTop10Image },
        { key: 'commercial', label: '商法', image: commercialTop10Image },
        { key: 'civil-procedure', label: '民诉法', image: civilProcedureTop10Image },
        { key: 'administrative', label: '行政法', image: administrativeTop10Image },
        { key: 'criminal-procedure', label: '刑诉法', image: criminalProcedureTop10Image }
      ]
    }
  },
  computed: {
    activeSubjectData() {
      return this.subjects.find(subject => subject.key === this.activeSubject) || {}
    },
    activeSubjectImage() {
      return this.activeSubjectData.image
    },
    activeSubjectLabel() {
      return this.activeSubjectData.label || ''
    }
  },
  methods: {
    setActiveSubject(key) {
      this.activeSubject = key
    }
  }
}
</script>

<style lang="scss" scoped>
.page-law-exam-top10 {
  min-height: 100vh;
  background: #eeeeee;
}

.report-shell {
  position: relative;
  z-index: 0;
  width: 375px;
  max-width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0 18px 32px;
  box-sizing: border-box;
  overflow: hidden;
  // The supplied background image only covers the header area. Keep its
  // bottom color as the page fallback so the long TOP10 image does not sit
  // on a second, darker red background.
  background-color: #ffeeed;
  background-image: url('~@/assets/law-exam/Rectangle.png');
  background-position: center top;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.hero {
  position: relative;
  z-index: 1;
  height: 268px;
}

.hero-image {
  display: block;
  position: absolute;
  top: 40px;
  left: 0;
  width: 247.4986px;
  height: 234.5594px;
}

.subject-tabs {
  position: relative;
  z-index: 2;
  display: flex;
  gap: 2px;
  width: 100%;
  height: 48px;
  padding: 4px;
  box-sizing: border-box;
  overflow-x: auto;
  background: #fff;
  border-radius: 14px;
  white-space: nowrap;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.subject-tabs::-webkit-scrollbar {
  display: none;
}

.subject-tab {
  flex: 0 0 auto;
  height: 40px;
  padding: 0 11px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #999;
  font-size: 13px;
  line-height: 40px;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.subject-tab.active {
  background: #f15b5b;
  color: #fff;
  font-weight: 600;
}

.subject-content {
  position: relative;
  z-index: 1;
  width: 100%;
  margin-top: 10px;
}

.top10-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 14px;
}

.subject-empty {
  min-height: 560px;
}

@media (max-width: 375px) {
  .report-shell {
    padding-right: 4.8vw;
    padding-left: 4.8vw;
  }

  .hero {
    height: 71.4667vw;
  }

  .hero-image {
    top: 10.6667vw;
    width: 66vw;
    height: 62.5492vw;
  }

  .subject-tabs {
    height: 12.8vw;
  }

  .subject-tab {
    height: calc(12.8vw - 8px);
    line-height: calc(12.8vw - 8px);
  }
}

@media (min-width: 376px) and (max-width: 767px) {
  .report-shell {
    width: 100%;
    max-width: none;
  }
}
</style>
